import * as React from 'react'

import useI18n from '@store/i18n/useI18n'

import ScreenContainer from '@components/screenContainer/screenContainer'

import styled from '@theme/styled-components'

import downloadCsv from '@utils/CSVutils'
interface Props {
  navigation: Navigation
}

const HABILITATION_INTERNE = 'https://phare.service-now.com/grdf?id=sc_cat_item&sys_id=c2ab8fdf97924910d6e6fdffe153afde'
const HABILITATION_EXTERNE = 'https://phare.service-now.com/grdf?id=sc_cat_item&sys_id=18fed70987605950a6ff535bbbbb3546'
const CSV_EXAMPLE = '"Prenom";"Nom";"Email";"Gaia";"Role";"Entreprise";"Regions"'
const CSV_LINK_EXAMPLE = '"AF NUM";"OS NUM";"EN_MAIL";"MAIL"'

const Information = ({ navigation }: Props) => {
  const i18n = useI18n()

  const navigateTo = (mode: string) => {
    switch (mode) {
      case 'interne':
        window.open(HABILITATION_INTERNE)
        break
      case 'externe':
        window.open(HABILITATION_EXTERNE)
        break
      case 'viewRegion':
        navigation.navigate('/monitor/region')
        break
      case 'csvExample':
        downloadCsv(CSV_EXAMPLE, 'Template CSV Import')
        break
      case 'csvLinkExample':
        downloadCsv(CSV_LINK_EXAMPLE, 'Template CSV Import Link')
        break
      case 'bugReport':
        window.open('https://phare.service-now.com/grdf?id=sc_cat_item&sys_id=835a05b137a7c200f111f01643990eee')
        break
      default:
        break
    }
  }

  const renderInternAuthorization = () => (
    <Line>
      <TitleSection>{i18n.t('components.information.internAuthorization.title')}</TitleSection>
      <ContentSection>
        <Paragraph>{i18n.t('components.information.internAuthorization.paragraph_1')}</Paragraph>
        <Paragraph>
          {i18n.t('components.information.internAuthorization.paragraph_2')}
          <GoToLink onClick={() => navigateTo('interne')}>{i18n.t('components.information.internProcess')}</GoToLink>
        </Paragraph>
        <Paragraph>
          {i18n.t('components.information.internAuthorization.paragraph_3')}
          <GoToLink onClick={() => navigateTo('csvExample')}>{i18n.t('components.information.exportExample')}</GoToLink>
        </Paragraph>
      </ContentSection>
    </Line>
  )

  const renderExternAuthorization = () => (
    <Line>
      <TitleSection> {i18n.t('components.information.externAuthorization.title')}</TitleSection>
      <ContentSection>
        <Paragraph>{i18n.t('components.information.externAuthorization.paragraph_1')}</Paragraph>
        <Paragraph>
          {i18n.t('components.information.externAuthorization.paragraph_2')}
          <GoToLink onClick={() => navigateTo('externe')}>{i18n.t('components.information.externProcess')}</GoToLink>
        </Paragraph>
        <Paragraph>
          {i18n.t('components.information.externAuthorization.paragraph_3')}
          <GoToLink onClick={() => navigateTo('csvExample')}>{i18n.t('components.information.exportExample')}</GoToLink>
        </Paragraph>
        <Paragraph>
          {i18n.t('components.information.externAuthorization.paragraph_4')}
          <GoToLink onClick={() => navigateTo('csvLinkExample')}>
            {i18n.t('components.information.exportExample')}
          </GoToLink>
        </Paragraph>
      </ContentSection>
    </Line>
  )

  const renderBugReport = () => (
    <Line>
      <TitleSection> {i18n.t('components.information.bugReport.title')} </TitleSection>
      <ContentSection>
        <Paragraph>
          {i18n.t('components.information.bugReport.paragraph_1')}
          <GoToLink onClick={() => navigateTo('bugReport')}>{i18n.t('components.information.bugReport.link')}</GoToLink>
        </Paragraph>
        <Paragraph>{i18n.t('components.information.bugReport.paragraph_2')}</Paragraph>
      </ContentSection>
    </Line>
  )

  const renderGoodPractice = () => (
    <Line>
      <TitleSection> {i18n.t('components.information.goodPractice.title')} </TitleSection>
      <ContentSection>
        <Paragraph>{i18n.t('components.information.goodPractice.paragraph_1')}</Paragraph>
      </ContentSection>
    </Line>
  )

  const renderPerimeter = () => (
    <Line>
      <TitleSection> {i18n.t('components.information.perimeter.title')} </TitleSection>
      <ContentSection>
        <Paragraph>{i18n.t('components.information.perimeter.paragraph_1')}</Paragraph>
      </ContentSection>
    </Line>
  )
  return (
    <ScreenContainer
      menu={
        <LeftContainer>
          <ScreenTitleContainer>
            <LeftTitle>{i18n.t('components.information.leftTitle')}</LeftTitle>
            <Back onClick={() => navigation.push('/')}>{i18n.t('components.menu.back')}</Back>
          </ScreenTitleContainer>
        </LeftContainer>
      }
      content={
        <RightContainer>
          <ScreenTitleContainer>
            <RightTitle>{i18n.t('components.information.rightTitle')}</RightTitle>
          </ScreenTitleContainer>
          <ul>
            {renderInternAuthorization()}
            {renderExternAuthorization()}
            {renderBugReport()}
            {renderGoodPractice()}
            {renderPerimeter()}
          </ul>
        </RightContainer>
      }
    />
  )
}
export default Information

const LeftContainer = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 10px 0 10px;
  overflow: hidden;
`
const LeftTitle = styled('div')`
  ${(props) => props.theme.fonts.title};
  margin-right: 20px;
`

const RightTitle = styled('div')`
  ${(props) => props.theme.fonts.bigTitle};
`
const ScreenTitleContainer = styled('div')`
  border: 0px solid ${(props) => props.theme.colors.menuBorder};
  border-bottom-width: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  margin: 0px 10px 15px 10px;
`
const Back = styled('div')`
  ${(props) => props.theme.fonts.backLibelle};
  cursor: pointer;
`
const RightContainer = styled('div')`
  background-color: ${(props) => props.theme.colors.filterBackgroundColor};
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 70px 50px 50px;
  justify-content: flex-start;
  overflow: scroll;
`
const Line = styled('li')`
  margin: 5px;
`
const GoToLink = styled('nav')`
  display: inline;
  text-decoration: underline;
  color: ${(props) => props.theme.colors.primary_blue};

  &: hover {
    cursor: pointer;
  }
`
const TitleSection = styled('div')`
  ${(props) => props.theme.fonts.title};
  margin-bottom: 8px;
  margin-top: 8px;
`
const ContentSection = styled('div')`
  ${(props) => props.theme.fonts.noLocationDescription};
  margin-bottom: 24px;
`

const Paragraph = styled('div')`
  ${(props) => props.theme.fonts.noLocationDescription};
  white-space: pre-line;
  text-align: justify;
`
